import { useListContext, useTranslate } from 'react-admin';
import { BarChartWithTrend } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { prepareTrendChartData } from '@/helpers/analytics/charts.js';
import { formatNumberWithComma } from '@/helpers/format/formatNumber.js';
import { AnalyticsChartTitle } from '@/components/analytics/common/AnalyticsChartTitle.jsx';
import { AnalyticsChartSubtitle } from '@/components/analytics/common/AnalyticsChartSubtitle.jsx';
import { ChartAnalyticsCard } from '@/components/analytics/common/ChartAnalyticsCard.jsx';

export const TransactionPackageAnalytics = () => {
    const { data } = useListContext();
    const translate = useTranslate();

    if (!data || data.length === 0) return null;
    const analytic = data[0].data;
    const previous = data[1].data;

    let series = data.find(s => s.id === 'series').data;
    const chartData = prepareTrendChartData(series, 'transactionsValidContainersCount');

    return (
        <ChartAnalyticsCard
            data={chartData}
            dataKey='transactionsValidContainersCount'
            stats={
                <>
                    <AnalyticsChartTitle
                        title={translate('resources.transaction.labels.packagesCount')}
                        value={analytic.transactionsValidContainersCount}
                        growth={
                            ((analytic.transactionsValidContainersCount - previous.transactionsValidContainersCount) /
                                previous.transactionsValidContainersCount) *
                            100
                        }
                    />
                    <AnalyticsChartSubtitle
                        label={translate('analytics.transaction.packagesPerTransaction')}
                        value={formatNumberWithComma(analytic.transactionsValidContainersCount / analytic.transactionsCount, 1)}
                    />
                </>
            }
            chart={
                <BarChartWithTrend
                    data={chartData}
                    dataKey='transactionsValidContainersCount'
                    label={translate('resources.transaction.labels.packagesCount')}
                />
            }
        />
    );
};
